import storage from './storage';
import {localListRecord,expireLocal} from './localMatch';
export async function localLists(username) {
  try {
  const profile=await storage.read(`profile:${username}`)||{};
  const records=await storage.localRecords(username), current=[];
  for(const state of records){
    const settled=state.actor==='human'?expireLocal(state):state;
    if(settled!==state)await storage.saveLocalMatch(settled,{activate:false});
    current.push(settled);
  }
  return {active:current.filter(state=>state.status==='playing').map(state=>localListRecord(state,profile)),finished:current.filter(state=>state.status!=='playing').slice(0,20).map(state=>localListRecord(state,profile)),invites:[]};
  }catch(_){return {active:[],finished:[],invites:[]};}
}
